.#{$namespace}-form-item {
	display: flex;
	margin-bottom: 18px;
	box-sizing: border-box;
	align-items: flex-start;

	&__label {
		display: inline-flex;
		align-items: center;
		flex: 0 0 auto;
		box-sizing: border-box;
		height: $control-height;
		padding: 0 12px 0 0;
		font-size: $font-size;
		color: $black-color;
		line-height: 1;
	}

	&__asterisk {
		color: color-token(danger);
		margin: 0 2px;
	}

	&__content {
		position: relative;
		flex: 1;
		min-width: 0;
		font-size: calc($font-size - 2px);
	}

	// 跟在控件后面占 content 文档流；absolute + top:100% 会贴 content 底边
	// 栅格同行被 textarea 撑高时 content 被 flex:1 拉高，文案会沉到整项底部
	&__error {
		padding-top: 2px;
		font-size: 12px;
		line-height: 1;
		color: color-token(danger);
	}

	&.is-error {
		.#{$namespace}-input,
		.#{$namespace}-textarea,
		.#{$namespace}-select,
		.#{$namespace}-upload,
		.#{$namespace}-number {
			border-color: color-token(danger);
		}
	}
}

// 对齐 Element Plus fade-in-linear（el-fade-in-linear）
.#{$namespace}-fade-in-linear-enter-active,
.#{$namespace}-fade-in-linear-leave-active {
	transition: opacity 0.2s linear;
}

.#{$namespace}-fade-in-linear-enter-from,
.#{$namespace}-fade-in-linear-leave-to {
	opacity: 0;
}
